module.exports = __webpack_public_path__ + "img/atomwise.6298803a.png";